import ApiGateway from '../aws/api-gateway/ApiGateway';
const apiRef = 'ConsumerApi';
const createSchedule = async (request) => {
    let response = { err: null, data: null };
    const lambdaInput = {
        generatorId: request.generatorId,
        userSk: request.userSk,
        inputs: request.inputObj,
    };
    // Coerce units into valid scheduler units
    let width = request.periodWidth;
    let newUnit = 'days';
    if (request.periodUnit === 'week') {
        width *= 7;
        newUnit = 'days';
    }
    const inputObj = {
        ScheduleName: request.name,
        GroupName: request.groupName,
        periodWidth: width,
        periodUnit: newUnit,
        inputObj: lambdaInput,
        startAtMS: request.startingAtMS,
    };
    console.log('Posting to Create Schedule with', inputObj);
    response = await ApiGateway.post('/scheduledReports/createSchedule', inputObj, apiRef);
    return response;
};
const createScheduleGroup = async (request) => {
    let response = { err: null, data: null };
    const nameValidationRe = new RegExp(/[0-9a-zA-Z-_.]+/);
    const nameChecked = nameValidationRe.exec(request.groupName);
    if ((nameChecked?.[0] ?? null) !== request.groupName) {
        response.err = new Error(`groupName ${request.groupName} is invalid for AWS scheduling. Must fit the form [0-9a-zA-Z-_.]+`);
        return response;
    }
    try {
        response = await ApiGateway.post('/scheduledReports/createScheduleGroup', { groupName: request.groupName }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * Gets a list of schedule summaries for one group.
 * @return ErrData with a list of schedules. If the group does not exist, err will say so.
 */
const listScheduledReportsForGroup = async (groupName) => {
    let response = { err: null, data: null };
    // Validate Group Name (must be [0-9a-zA-Z-_.]+)
    const nameValidationRe = new RegExp(/[0-9a-zA-Z-_.]+/);
    const nameChecked = nameValidationRe.exec(groupName);
    if ((nameChecked?.[0] ?? null) !== groupName) {
        response.err = new Error(`groupName ${groupName} is invalid for AWS scheduling. Must fit the form [0-9a-zA-Z-_.]+`);
        return response;
    }
    // Post
    try {
        response = await ApiGateway.post('/scheduledReports/listSchedulesForGroup', { groupName: groupName }, apiRef);
        if (response.err) {
            console.log('Err: got error in post, reportDao list schedules for group', response.err);
        }
    }
    catch (e) {
        console.log('Err cought in post');
        response.err = e.message;
    }
    return response;
};
const getSchedulesForGroup = async (groupName) => {
    let response = { err: null, data: null };
    // Validate Group Name (must be [0-9a-zA-Z-_.]+)
    const nameValidationRe = new RegExp(/[0-9a-zA-Z-_.]+/);
    const nameChecked = nameValidationRe.exec(groupName);
    if ((nameChecked?.[0] ?? null) !== groupName) {
        response.err = new Error(`groupName ${groupName} is invalid for AWS scheduling. Must fit the form [0-9a-zA-Z-_.]+`);
        return response;
    }
    try {
        let listRes = { err: null, data: null };
        listRes = await ApiGateway.post('/scheduledReports/listSchedulesForGroup', { groupName: groupName }, apiRef);
        if (listRes.err) {
            console.log('Err: got error in post, reportDao list schedules for group', response.err);
            response.err = listRes.err;
        }
        if (listRes.data) {
            const schedulePromises = listRes.data.map((summary) => new Promise(async (res, rej) => {
                let schedule_res = await ApiGateway.post('/scheduledReports/getSchedule', { groupName: groupName, scheduleName: summary.Name }, apiRef);
                if (schedule_res.data) {
                    res(schedule_res.data);
                }
                else {
                    rej(schedule_res.err);
                }
            }));
            const promises_reses = await Promise.allSettled(schedulePromises);
            const rejections = promises_reses.filter((r) => r.status === 'rejected');
            console.log('Rejections', rejections);
            const resolved = promises_reses.filter((r) => r.status === 'fulfilled');
            // TOOD err processing on rejections n stuff
            response.data = { schedules: resolved.map((r) => r.value) };
        }
    }
    catch (e) {
        console.log('getSchedulesForGroup: Err caught in post');
        response.err = e.message;
    }
    return response;
};
const deleteSchedule = async (groupName, scheduleName) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/scheduledReports/deleteSchedule', { groupName, scheduleName }, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
export const ScheduledReportsDAO = {
    createSchedule,
    createScheduleGroup,
    listScheduledReportsForGroup,
    getSchedulesForGroup,
    deleteSchedule,
};
